import { default as indexIrGgxOUFCtMeta } from "/home/forge/app.inaia.finance/pages/cash-balance/index.vue?macro=true";
import { default as indexgpEVhpV2bwMeta } from "/home/forge/app.inaia.finance/pages/cash-balance/top-up/index.vue?macro=true";
import { default as index3AgtkfZrtkMeta } from "/home/forge/app.inaia.finance/pages/cash-balance/withdraw/index.vue?macro=true";
import { default as dashboardC64J17F0nyMeta } from "/home/forge/app.inaia.finance/pages/dashboard.vue?macro=true";
import { default as _91type_93wDVQYMDWxkMeta } from "/home/forge/app.inaia.finance/pages/depot/[type].vue?macro=true";
import { default as _91id_93qyUp7hBUHyMeta } from "/home/forge/app.inaia.finance/pages/depot/addsavingplan/[id].vue?macro=true";
import { default as _91id_932V5CPB6ZCmMeta } from "/home/forge/app.inaia.finance/pages/depot/detail/[id].vue?macro=true";
import { default as _91type_935UO0e4WOYaMeta } from "/home/forge/app.inaia.finance/pages/depot/new/[type].vue?macro=true";
import { default as indexEFdByxiBJEMeta } from "/home/forge/app.inaia.finance/pages/etf-transaction-history/index.vue?macro=true";
import { default as indexGUtwRlOxXvMeta } from "/home/forge/app.inaia.finance/pages/inbox-message/index.vue?macro=true";
import { default as indexOvUiruzTTvMeta } from "/home/forge/app.inaia.finance/pages/index.vue?macro=true";
import { default as _91_91isin_93_931zYvIruoYSMeta } from "/home/forge/app.inaia.finance/pages/instruments/buy/[[isin]].vue?macro=true";
import { default as _91isin_93Fk9HRtibUyMeta } from "/home/forge/app.inaia.finance/pages/instruments/details/[isin].vue?macro=true";
import { default as indexkrme2yRYAFMeta } from "/home/forge/app.inaia.finance/pages/instruments/index.vue?macro=true";
import { default as indextrsavF5TMxMeta } from "/home/forge/app.inaia.finance/pages/instruments/list/index.vue?macro=true";
import { default as _91_91isin_93_93r0o1ddojy4Meta } from "/home/forge/app.inaia.finance/pages/instruments/savings-plan/add/[[isin]].vue?macro=true";
import { default as _91_91isin_93_93EVgfSFISmOMeta } from "/home/forge/app.inaia.finance/pages/instruments/sell/[[isin]].vue?macro=true";
import { default as indexdc6l0lodPeMeta } from "/home/forge/app.inaia.finance/pages/instruments/tax-exemption/index.vue?macro=true";
import { default as loginASnEeWn2yPMeta } from "/home/forge/app.inaia.finance/pages/login.vue?macro=true";
import { default as indexQiHbQchnSjMeta } from "/home/forge/app.inaia.finance/pages/profile/index.vue?macro=true";
import { default as verifyzbMecNqNgQMeta } from "/home/forge/app.inaia.finance/pages/profile/verify.vue?macro=true";
import { default as registereWhXprJEglMeta } from "/home/forge/app.inaia.finance/pages/register.vue?macro=true";
import { default as request_45passwordhM73VLHqraMeta } from "/home/forge/app.inaia.finance/pages/request-password.vue?macro=true";
import { default as reset_45passwordZ74mikPZ7MMeta } from "/home/forge/app.inaia.finance/pages/reset-password.vue?macro=true";
import { default as reset_45pin7CKcxd04hmMeta } from "/home/forge/app.inaia.finance/pages/reset-pin.vue?macro=true";
import { default as indexrEmhM3k7xbMeta } from "/home/forge/app.inaia.finance/pages/security-legal-document/index.vue?macro=true";
import { default as simulatore2TEqHOXDxMeta } from "/home/forge/app.inaia.finance/pages/simulator.vue?macro=true";
import { default as indexFqd3lbx2VMMeta } from "/home/forge/app.inaia.finance/pages/support-tickets/index.vue?macro=true";
import { default as _91_91depotid_93_936YhjF27tuCMeta } from "/home/forge/app.inaia.finance/pages/trading/buy/[[depotid]].vue?macro=true";
import { default as _91_91depotid_93_93WQh3nPAOfIMeta } from "/home/forge/app.inaia.finance/pages/trading/delivery/[[depotid]].vue?macro=true";
import { default as _91_91depotid_93_93GEdaDc0wI1Meta } from "/home/forge/app.inaia.finance/pages/trading/sell/[[depotid]].vue?macro=true";
import { default as _91_91depotid_93_93EKe0ekZLN3Meta } from "/home/forge/app.inaia.finance/pages/trading/transfer/[[depotid]].vue?macro=true";
import { default as indexmcUOWVxIfvMeta } from "/home/forge/app.inaia.finance/pages/upvest-account-history/index.vue?macro=true";
import { default as indexcPTOgg0GhUMeta } from "/home/forge/app.inaia.finance/pages/upvest-activate/index.vue?macro=true";
export default [
  {
    name: indexIrGgxOUFCtMeta?.name ?? "cash-balance___de",
    path: indexIrGgxOUFCtMeta?.path ?? "/de/cash-balance",
    meta: indexIrGgxOUFCtMeta || {},
    alias: indexIrGgxOUFCtMeta?.alias || [],
    redirect: indexIrGgxOUFCtMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/cash-balance/index.vue").then(m => m.default || m)
  },
  {
    name: indexIrGgxOUFCtMeta?.name ?? "cash-balance___en",
    path: indexIrGgxOUFCtMeta?.path ?? "/en/cash-balance",
    meta: indexIrGgxOUFCtMeta || {},
    alias: indexIrGgxOUFCtMeta?.alias || [],
    redirect: indexIrGgxOUFCtMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/cash-balance/index.vue").then(m => m.default || m)
  },
  {
    name: indexIrGgxOUFCtMeta?.name ?? "cash-balance___fr",
    path: indexIrGgxOUFCtMeta?.path ?? "/fr/cash-balance",
    meta: indexIrGgxOUFCtMeta || {},
    alias: indexIrGgxOUFCtMeta?.alias || [],
    redirect: indexIrGgxOUFCtMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/cash-balance/index.vue").then(m => m.default || m)
  },
  {
    name: indexgpEVhpV2bwMeta?.name ?? "cash-balance-top-up___de",
    path: indexgpEVhpV2bwMeta?.path ?? "/de/cash-balance/top-up",
    meta: indexgpEVhpV2bwMeta || {},
    alias: indexgpEVhpV2bwMeta?.alias || [],
    redirect: indexgpEVhpV2bwMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/cash-balance/top-up/index.vue").then(m => m.default || m)
  },
  {
    name: indexgpEVhpV2bwMeta?.name ?? "cash-balance-top-up___en",
    path: indexgpEVhpV2bwMeta?.path ?? "/en/cash-balance/top-up",
    meta: indexgpEVhpV2bwMeta || {},
    alias: indexgpEVhpV2bwMeta?.alias || [],
    redirect: indexgpEVhpV2bwMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/cash-balance/top-up/index.vue").then(m => m.default || m)
  },
  {
    name: indexgpEVhpV2bwMeta?.name ?? "cash-balance-top-up___fr",
    path: indexgpEVhpV2bwMeta?.path ?? "/fr/cash-balance/top-up",
    meta: indexgpEVhpV2bwMeta || {},
    alias: indexgpEVhpV2bwMeta?.alias || [],
    redirect: indexgpEVhpV2bwMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/cash-balance/top-up/index.vue").then(m => m.default || m)
  },
  {
    name: index3AgtkfZrtkMeta?.name ?? "cash-balance-withdraw___de",
    path: index3AgtkfZrtkMeta?.path ?? "/de/cash-balance/withdraw",
    meta: index3AgtkfZrtkMeta || {},
    alias: index3AgtkfZrtkMeta?.alias || [],
    redirect: index3AgtkfZrtkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/cash-balance/withdraw/index.vue").then(m => m.default || m)
  },
  {
    name: index3AgtkfZrtkMeta?.name ?? "cash-balance-withdraw___en",
    path: index3AgtkfZrtkMeta?.path ?? "/en/cash-balance/withdraw",
    meta: index3AgtkfZrtkMeta || {},
    alias: index3AgtkfZrtkMeta?.alias || [],
    redirect: index3AgtkfZrtkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/cash-balance/withdraw/index.vue").then(m => m.default || m)
  },
  {
    name: index3AgtkfZrtkMeta?.name ?? "cash-balance-withdraw___fr",
    path: index3AgtkfZrtkMeta?.path ?? "/fr/cash-balance/withdraw",
    meta: index3AgtkfZrtkMeta || {},
    alias: index3AgtkfZrtkMeta?.alias || [],
    redirect: index3AgtkfZrtkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/cash-balance/withdraw/index.vue").then(m => m.default || m)
  },
  {
    name: dashboardC64J17F0nyMeta?.name ?? "dashboard___de",
    path: dashboardC64J17F0nyMeta?.path ?? "/de/dashboard",
    meta: dashboardC64J17F0nyMeta || {},
    alias: dashboardC64J17F0nyMeta?.alias || [],
    redirect: dashboardC64J17F0nyMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: dashboardC64J17F0nyMeta?.name ?? "dashboard___en",
    path: dashboardC64J17F0nyMeta?.path ?? "/en/dashboard",
    meta: dashboardC64J17F0nyMeta || {},
    alias: dashboardC64J17F0nyMeta?.alias || [],
    redirect: dashboardC64J17F0nyMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: dashboardC64J17F0nyMeta?.name ?? "dashboard___fr",
    path: dashboardC64J17F0nyMeta?.path ?? "/fr/dashboard",
    meta: dashboardC64J17F0nyMeta || {},
    alias: dashboardC64J17F0nyMeta?.alias || [],
    redirect: dashboardC64J17F0nyMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: _91type_93wDVQYMDWxkMeta?.name ?? "depot-type___de",
    path: _91type_93wDVQYMDWxkMeta?.path ?? "/de/depot/:type()",
    meta: _91type_93wDVQYMDWxkMeta || {},
    alias: _91type_93wDVQYMDWxkMeta?.alias || [],
    redirect: _91type_93wDVQYMDWxkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/depot/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93wDVQYMDWxkMeta?.name ?? "depot-type___en",
    path: _91type_93wDVQYMDWxkMeta?.path ?? "/en/depot/:type()",
    meta: _91type_93wDVQYMDWxkMeta || {},
    alias: _91type_93wDVQYMDWxkMeta?.alias || [],
    redirect: _91type_93wDVQYMDWxkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/depot/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93wDVQYMDWxkMeta?.name ?? "depot-type___fr",
    path: _91type_93wDVQYMDWxkMeta?.path ?? "/fr/depot/:type()",
    meta: _91type_93wDVQYMDWxkMeta || {},
    alias: _91type_93wDVQYMDWxkMeta?.alias || [],
    redirect: _91type_93wDVQYMDWxkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/depot/[type].vue").then(m => m.default || m)
  },
  {
    name: _91id_93qyUp7hBUHyMeta?.name ?? "depot-addsavingplan-id___de",
    path: _91id_93qyUp7hBUHyMeta?.path ?? "/de/depot/addsavingplan/:id()",
    meta: _91id_93qyUp7hBUHyMeta || {},
    alias: _91id_93qyUp7hBUHyMeta?.alias || [],
    redirect: _91id_93qyUp7hBUHyMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/depot/addsavingplan/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93qyUp7hBUHyMeta?.name ?? "depot-addsavingplan-id___en",
    path: _91id_93qyUp7hBUHyMeta?.path ?? "/en/depot/addsavingplan/:id()",
    meta: _91id_93qyUp7hBUHyMeta || {},
    alias: _91id_93qyUp7hBUHyMeta?.alias || [],
    redirect: _91id_93qyUp7hBUHyMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/depot/addsavingplan/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93qyUp7hBUHyMeta?.name ?? "depot-addsavingplan-id___fr",
    path: _91id_93qyUp7hBUHyMeta?.path ?? "/fr/depot/addsavingplan/:id()",
    meta: _91id_93qyUp7hBUHyMeta || {},
    alias: _91id_93qyUp7hBUHyMeta?.alias || [],
    redirect: _91id_93qyUp7hBUHyMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/depot/addsavingplan/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_932V5CPB6ZCmMeta?.name ?? "depot-detail-id___de",
    path: _91id_932V5CPB6ZCmMeta?.path ?? "/de/depot/detail/:id()",
    meta: _91id_932V5CPB6ZCmMeta || {},
    alias: _91id_932V5CPB6ZCmMeta?.alias || [],
    redirect: _91id_932V5CPB6ZCmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/depot/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_932V5CPB6ZCmMeta?.name ?? "depot-detail-id___en",
    path: _91id_932V5CPB6ZCmMeta?.path ?? "/en/depot/detail/:id()",
    meta: _91id_932V5CPB6ZCmMeta || {},
    alias: _91id_932V5CPB6ZCmMeta?.alias || [],
    redirect: _91id_932V5CPB6ZCmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/depot/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_932V5CPB6ZCmMeta?.name ?? "depot-detail-id___fr",
    path: _91id_932V5CPB6ZCmMeta?.path ?? "/fr/depot/detail/:id()",
    meta: _91id_932V5CPB6ZCmMeta || {},
    alias: _91id_932V5CPB6ZCmMeta?.alias || [],
    redirect: _91id_932V5CPB6ZCmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/depot/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91type_935UO0e4WOYaMeta?.name ?? "depot-new-type___de",
    path: _91type_935UO0e4WOYaMeta?.path ?? "/de/depot/new/:type()",
    meta: _91type_935UO0e4WOYaMeta || {},
    alias: _91type_935UO0e4WOYaMeta?.alias || [],
    redirect: _91type_935UO0e4WOYaMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/depot/new/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_935UO0e4WOYaMeta?.name ?? "depot-new-type___en",
    path: _91type_935UO0e4WOYaMeta?.path ?? "/en/depot/new/:type()",
    meta: _91type_935UO0e4WOYaMeta || {},
    alias: _91type_935UO0e4WOYaMeta?.alias || [],
    redirect: _91type_935UO0e4WOYaMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/depot/new/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_935UO0e4WOYaMeta?.name ?? "depot-new-type___fr",
    path: _91type_935UO0e4WOYaMeta?.path ?? "/fr/depot/new/:type()",
    meta: _91type_935UO0e4WOYaMeta || {},
    alias: _91type_935UO0e4WOYaMeta?.alias || [],
    redirect: _91type_935UO0e4WOYaMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/depot/new/[type].vue").then(m => m.default || m)
  },
  {
    name: indexEFdByxiBJEMeta?.name ?? "etf-transaction-history___de",
    path: indexEFdByxiBJEMeta?.path ?? "/de/etf-transaction-history",
    meta: indexEFdByxiBJEMeta || {},
    alias: indexEFdByxiBJEMeta?.alias || [],
    redirect: indexEFdByxiBJEMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/etf-transaction-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexEFdByxiBJEMeta?.name ?? "etf-transaction-history___en",
    path: indexEFdByxiBJEMeta?.path ?? "/en/etf-transaction-history",
    meta: indexEFdByxiBJEMeta || {},
    alias: indexEFdByxiBJEMeta?.alias || [],
    redirect: indexEFdByxiBJEMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/etf-transaction-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexEFdByxiBJEMeta?.name ?? "etf-transaction-history___fr",
    path: indexEFdByxiBJEMeta?.path ?? "/fr/etf-transaction-history",
    meta: indexEFdByxiBJEMeta || {},
    alias: indexEFdByxiBJEMeta?.alias || [],
    redirect: indexEFdByxiBJEMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/etf-transaction-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexGUtwRlOxXvMeta?.name ?? "inbox-message___de",
    path: indexGUtwRlOxXvMeta?.path ?? "/de/inbox-message",
    meta: indexGUtwRlOxXvMeta || {},
    alias: indexGUtwRlOxXvMeta?.alias || [],
    redirect: indexGUtwRlOxXvMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/inbox-message/index.vue").then(m => m.default || m)
  },
  {
    name: indexGUtwRlOxXvMeta?.name ?? "inbox-message___en",
    path: indexGUtwRlOxXvMeta?.path ?? "/en/inbox-message",
    meta: indexGUtwRlOxXvMeta || {},
    alias: indexGUtwRlOxXvMeta?.alias || [],
    redirect: indexGUtwRlOxXvMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/inbox-message/index.vue").then(m => m.default || m)
  },
  {
    name: indexGUtwRlOxXvMeta?.name ?? "inbox-message___fr",
    path: indexGUtwRlOxXvMeta?.path ?? "/fr/inbox-message",
    meta: indexGUtwRlOxXvMeta || {},
    alias: indexGUtwRlOxXvMeta?.alias || [],
    redirect: indexGUtwRlOxXvMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/inbox-message/index.vue").then(m => m.default || m)
  },
  {
    name: indexOvUiruzTTvMeta?.name ?? "index___de",
    path: indexOvUiruzTTvMeta?.path ?? "/de",
    meta: indexOvUiruzTTvMeta || {},
    alias: indexOvUiruzTTvMeta?.alias || [],
    redirect: indexOvUiruzTTvMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexOvUiruzTTvMeta?.name ?? "index___en",
    path: indexOvUiruzTTvMeta?.path ?? "/en",
    meta: indexOvUiruzTTvMeta || {},
    alias: indexOvUiruzTTvMeta?.alias || [],
    redirect: indexOvUiruzTTvMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexOvUiruzTTvMeta?.name ?? "index___fr",
    path: indexOvUiruzTTvMeta?.path ?? "/fr",
    meta: indexOvUiruzTTvMeta || {},
    alias: indexOvUiruzTTvMeta?.alias || [],
    redirect: indexOvUiruzTTvMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_931zYvIruoYSMeta?.name ?? "instruments-buy-isin___de",
    path: _91_91isin_93_931zYvIruoYSMeta?.path ?? "/de/instruments/buy/:isin?",
    meta: _91_91isin_93_931zYvIruoYSMeta || {},
    alias: _91_91isin_93_931zYvIruoYSMeta?.alias || [],
    redirect: _91_91isin_93_931zYvIruoYSMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/buy/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_931zYvIruoYSMeta?.name ?? "instruments-buy-isin___en",
    path: _91_91isin_93_931zYvIruoYSMeta?.path ?? "/en/instruments/buy/:isin?",
    meta: _91_91isin_93_931zYvIruoYSMeta || {},
    alias: _91_91isin_93_931zYvIruoYSMeta?.alias || [],
    redirect: _91_91isin_93_931zYvIruoYSMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/buy/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_931zYvIruoYSMeta?.name ?? "instruments-buy-isin___fr",
    path: _91_91isin_93_931zYvIruoYSMeta?.path ?? "/fr/instruments/buy/:isin?",
    meta: _91_91isin_93_931zYvIruoYSMeta || {},
    alias: _91_91isin_93_931zYvIruoYSMeta?.alias || [],
    redirect: _91_91isin_93_931zYvIruoYSMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/buy/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91isin_93Fk9HRtibUyMeta?.name ?? "instruments-details-isin___de",
    path: _91isin_93Fk9HRtibUyMeta?.path ?? "/de/instruments/details/:isin()",
    meta: _91isin_93Fk9HRtibUyMeta || {},
    alias: _91isin_93Fk9HRtibUyMeta?.alias || [],
    redirect: _91isin_93Fk9HRtibUyMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/details/[isin].vue").then(m => m.default || m)
  },
  {
    name: _91isin_93Fk9HRtibUyMeta?.name ?? "instruments-details-isin___en",
    path: _91isin_93Fk9HRtibUyMeta?.path ?? "/en/instruments/details/:isin()",
    meta: _91isin_93Fk9HRtibUyMeta || {},
    alias: _91isin_93Fk9HRtibUyMeta?.alias || [],
    redirect: _91isin_93Fk9HRtibUyMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/details/[isin].vue").then(m => m.default || m)
  },
  {
    name: _91isin_93Fk9HRtibUyMeta?.name ?? "instruments-details-isin___fr",
    path: _91isin_93Fk9HRtibUyMeta?.path ?? "/fr/instruments/details/:isin()",
    meta: _91isin_93Fk9HRtibUyMeta || {},
    alias: _91isin_93Fk9HRtibUyMeta?.alias || [],
    redirect: _91isin_93Fk9HRtibUyMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/details/[isin].vue").then(m => m.default || m)
  },
  {
    name: indexkrme2yRYAFMeta?.name ?? "instruments___de",
    path: indexkrme2yRYAFMeta?.path ?? "/de/instruments",
    meta: indexkrme2yRYAFMeta || {},
    alias: indexkrme2yRYAFMeta?.alias || [],
    redirect: indexkrme2yRYAFMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/index.vue").then(m => m.default || m)
  },
  {
    name: indexkrme2yRYAFMeta?.name ?? "instruments___en",
    path: indexkrme2yRYAFMeta?.path ?? "/en/instruments",
    meta: indexkrme2yRYAFMeta || {},
    alias: indexkrme2yRYAFMeta?.alias || [],
    redirect: indexkrme2yRYAFMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/index.vue").then(m => m.default || m)
  },
  {
    name: indexkrme2yRYAFMeta?.name ?? "instruments___fr",
    path: indexkrme2yRYAFMeta?.path ?? "/fr/instruments",
    meta: indexkrme2yRYAFMeta || {},
    alias: indexkrme2yRYAFMeta?.alias || [],
    redirect: indexkrme2yRYAFMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/index.vue").then(m => m.default || m)
  },
  {
    name: indextrsavF5TMxMeta?.name ?? "instruments-list___de",
    path: indextrsavF5TMxMeta?.path ?? "/de/instruments/list",
    meta: indextrsavF5TMxMeta || {},
    alias: indextrsavF5TMxMeta?.alias || [],
    redirect: indextrsavF5TMxMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/list/index.vue").then(m => m.default || m)
  },
  {
    name: indextrsavF5TMxMeta?.name ?? "instruments-list___en",
    path: indextrsavF5TMxMeta?.path ?? "/en/instruments/list",
    meta: indextrsavF5TMxMeta || {},
    alias: indextrsavF5TMxMeta?.alias || [],
    redirect: indextrsavF5TMxMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/list/index.vue").then(m => m.default || m)
  },
  {
    name: indextrsavF5TMxMeta?.name ?? "instruments-list___fr",
    path: indextrsavF5TMxMeta?.path ?? "/fr/instruments/list",
    meta: indextrsavF5TMxMeta || {},
    alias: indextrsavF5TMxMeta?.alias || [],
    redirect: indextrsavF5TMxMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/list/index.vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93r0o1ddojy4Meta?.name ?? "instruments-savings-plan-add-isin___de",
    path: _91_91isin_93_93r0o1ddojy4Meta?.path ?? "/de/instruments/savings-plan/add/:isin?",
    meta: _91_91isin_93_93r0o1ddojy4Meta || {},
    alias: _91_91isin_93_93r0o1ddojy4Meta?.alias || [],
    redirect: _91_91isin_93_93r0o1ddojy4Meta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/savings-plan/add/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93r0o1ddojy4Meta?.name ?? "instruments-savings-plan-add-isin___en",
    path: _91_91isin_93_93r0o1ddojy4Meta?.path ?? "/en/instruments/savings-plan/add/:isin?",
    meta: _91_91isin_93_93r0o1ddojy4Meta || {},
    alias: _91_91isin_93_93r0o1ddojy4Meta?.alias || [],
    redirect: _91_91isin_93_93r0o1ddojy4Meta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/savings-plan/add/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93r0o1ddojy4Meta?.name ?? "instruments-savings-plan-add-isin___fr",
    path: _91_91isin_93_93r0o1ddojy4Meta?.path ?? "/fr/instruments/savings-plan/add/:isin?",
    meta: _91_91isin_93_93r0o1ddojy4Meta || {},
    alias: _91_91isin_93_93r0o1ddojy4Meta?.alias || [],
    redirect: _91_91isin_93_93r0o1ddojy4Meta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/savings-plan/add/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93EVgfSFISmOMeta?.name ?? "instruments-sell-isin___de",
    path: _91_91isin_93_93EVgfSFISmOMeta?.path ?? "/de/instruments/sell/:isin?",
    meta: _91_91isin_93_93EVgfSFISmOMeta || {},
    alias: _91_91isin_93_93EVgfSFISmOMeta?.alias || [],
    redirect: _91_91isin_93_93EVgfSFISmOMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/sell/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93EVgfSFISmOMeta?.name ?? "instruments-sell-isin___en",
    path: _91_91isin_93_93EVgfSFISmOMeta?.path ?? "/en/instruments/sell/:isin?",
    meta: _91_91isin_93_93EVgfSFISmOMeta || {},
    alias: _91_91isin_93_93EVgfSFISmOMeta?.alias || [],
    redirect: _91_91isin_93_93EVgfSFISmOMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/sell/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93EVgfSFISmOMeta?.name ?? "instruments-sell-isin___fr",
    path: _91_91isin_93_93EVgfSFISmOMeta?.path ?? "/fr/instruments/sell/:isin?",
    meta: _91_91isin_93_93EVgfSFISmOMeta || {},
    alias: _91_91isin_93_93EVgfSFISmOMeta?.alias || [],
    redirect: _91_91isin_93_93EVgfSFISmOMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/sell/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: indexdc6l0lodPeMeta?.name ?? "instruments-tax-exemption___de",
    path: indexdc6l0lodPeMeta?.path ?? "/de/instruments/tax-exemption",
    meta: indexdc6l0lodPeMeta || {},
    alias: indexdc6l0lodPeMeta?.alias || [],
    redirect: indexdc6l0lodPeMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/tax-exemption/index.vue").then(m => m.default || m)
  },
  {
    name: indexdc6l0lodPeMeta?.name ?? "instruments-tax-exemption___en",
    path: indexdc6l0lodPeMeta?.path ?? "/en/instruments/tax-exemption",
    meta: indexdc6l0lodPeMeta || {},
    alias: indexdc6l0lodPeMeta?.alias || [],
    redirect: indexdc6l0lodPeMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/tax-exemption/index.vue").then(m => m.default || m)
  },
  {
    name: indexdc6l0lodPeMeta?.name ?? "instruments-tax-exemption___fr",
    path: indexdc6l0lodPeMeta?.path ?? "/fr/instruments/tax-exemption",
    meta: indexdc6l0lodPeMeta || {},
    alias: indexdc6l0lodPeMeta?.alias || [],
    redirect: indexdc6l0lodPeMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/instruments/tax-exemption/index.vue").then(m => m.default || m)
  },
  {
    name: loginASnEeWn2yPMeta?.name ?? "login___de",
    path: loginASnEeWn2yPMeta?.path ?? "/de/login",
    meta: loginASnEeWn2yPMeta || {},
    alias: loginASnEeWn2yPMeta?.alias || [],
    redirect: loginASnEeWn2yPMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginASnEeWn2yPMeta?.name ?? "login___en",
    path: loginASnEeWn2yPMeta?.path ?? "/en/login",
    meta: loginASnEeWn2yPMeta || {},
    alias: loginASnEeWn2yPMeta?.alias || [],
    redirect: loginASnEeWn2yPMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginASnEeWn2yPMeta?.name ?? "login___fr",
    path: loginASnEeWn2yPMeta?.path ?? "/fr/login",
    meta: loginASnEeWn2yPMeta || {},
    alias: loginASnEeWn2yPMeta?.alias || [],
    redirect: loginASnEeWn2yPMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/login.vue").then(m => m.default || m)
  },
  {
    name: indexQiHbQchnSjMeta?.name ?? "profile___de",
    path: indexQiHbQchnSjMeta?.path ?? "/de/profile",
    meta: indexQiHbQchnSjMeta || {},
    alias: indexQiHbQchnSjMeta?.alias || [],
    redirect: indexQiHbQchnSjMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexQiHbQchnSjMeta?.name ?? "profile___en",
    path: indexQiHbQchnSjMeta?.path ?? "/en/profile",
    meta: indexQiHbQchnSjMeta || {},
    alias: indexQiHbQchnSjMeta?.alias || [],
    redirect: indexQiHbQchnSjMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexQiHbQchnSjMeta?.name ?? "profile___fr",
    path: indexQiHbQchnSjMeta?.path ?? "/fr/profile",
    meta: indexQiHbQchnSjMeta || {},
    alias: indexQiHbQchnSjMeta?.alias || [],
    redirect: indexQiHbQchnSjMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: verifyzbMecNqNgQMeta?.name ?? "profile-verify___de",
    path: verifyzbMecNqNgQMeta?.path ?? "/de/profile/verify",
    meta: verifyzbMecNqNgQMeta || {},
    alias: verifyzbMecNqNgQMeta?.alias || [],
    redirect: verifyzbMecNqNgQMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/profile/verify.vue").then(m => m.default || m)
  },
  {
    name: verifyzbMecNqNgQMeta?.name ?? "profile-verify___en",
    path: verifyzbMecNqNgQMeta?.path ?? "/en/profile/verify",
    meta: verifyzbMecNqNgQMeta || {},
    alias: verifyzbMecNqNgQMeta?.alias || [],
    redirect: verifyzbMecNqNgQMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/profile/verify.vue").then(m => m.default || m)
  },
  {
    name: verifyzbMecNqNgQMeta?.name ?? "profile-verify___fr",
    path: verifyzbMecNqNgQMeta?.path ?? "/fr/profile/verify",
    meta: verifyzbMecNqNgQMeta || {},
    alias: verifyzbMecNqNgQMeta?.alias || [],
    redirect: verifyzbMecNqNgQMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/profile/verify.vue").then(m => m.default || m)
  },
  {
    name: registereWhXprJEglMeta?.name ?? "register___de",
    path: registereWhXprJEglMeta?.path ?? "/de/register",
    meta: registereWhXprJEglMeta || {},
    alias: registereWhXprJEglMeta?.alias || [],
    redirect: registereWhXprJEglMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registereWhXprJEglMeta?.name ?? "register___en",
    path: registereWhXprJEglMeta?.path ?? "/en/register",
    meta: registereWhXprJEglMeta || {},
    alias: registereWhXprJEglMeta?.alias || [],
    redirect: registereWhXprJEglMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registereWhXprJEglMeta?.name ?? "register___fr",
    path: registereWhXprJEglMeta?.path ?? "/fr/register",
    meta: registereWhXprJEglMeta || {},
    alias: registereWhXprJEglMeta?.alias || [],
    redirect: registereWhXprJEglMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/register.vue").then(m => m.default || m)
  },
  {
    name: request_45passwordhM73VLHqraMeta?.name ?? "request-password___de",
    path: request_45passwordhM73VLHqraMeta?.path ?? "/de/request-password",
    meta: request_45passwordhM73VLHqraMeta || {},
    alias: request_45passwordhM73VLHqraMeta?.alias || [],
    redirect: request_45passwordhM73VLHqraMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/request-password.vue").then(m => m.default || m)
  },
  {
    name: request_45passwordhM73VLHqraMeta?.name ?? "request-password___en",
    path: request_45passwordhM73VLHqraMeta?.path ?? "/en/request-password",
    meta: request_45passwordhM73VLHqraMeta || {},
    alias: request_45passwordhM73VLHqraMeta?.alias || [],
    redirect: request_45passwordhM73VLHqraMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/request-password.vue").then(m => m.default || m)
  },
  {
    name: request_45passwordhM73VLHqraMeta?.name ?? "request-password___fr",
    path: request_45passwordhM73VLHqraMeta?.path ?? "/fr/request-password",
    meta: request_45passwordhM73VLHqraMeta || {},
    alias: request_45passwordhM73VLHqraMeta?.alias || [],
    redirect: request_45passwordhM73VLHqraMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/request-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordZ74mikPZ7MMeta?.name ?? "reset-password___de",
    path: reset_45passwordZ74mikPZ7MMeta?.path ?? "/de/reset-password",
    meta: reset_45passwordZ74mikPZ7MMeta || {},
    alias: reset_45passwordZ74mikPZ7MMeta?.alias || [],
    redirect: reset_45passwordZ74mikPZ7MMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordZ74mikPZ7MMeta?.name ?? "reset-password___en",
    path: reset_45passwordZ74mikPZ7MMeta?.path ?? "/en/reset-password",
    meta: reset_45passwordZ74mikPZ7MMeta || {},
    alias: reset_45passwordZ74mikPZ7MMeta?.alias || [],
    redirect: reset_45passwordZ74mikPZ7MMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordZ74mikPZ7MMeta?.name ?? "reset-password___fr",
    path: reset_45passwordZ74mikPZ7MMeta?.path ?? "/fr/reset-password",
    meta: reset_45passwordZ74mikPZ7MMeta || {},
    alias: reset_45passwordZ74mikPZ7MMeta?.alias || [],
    redirect: reset_45passwordZ74mikPZ7MMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45pin7CKcxd04hmMeta?.name ?? "reset-pin___de",
    path: reset_45pin7CKcxd04hmMeta?.path ?? "/de/reset-pin",
    meta: reset_45pin7CKcxd04hmMeta || {},
    alias: reset_45pin7CKcxd04hmMeta?.alias || [],
    redirect: reset_45pin7CKcxd04hmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/reset-pin.vue").then(m => m.default || m)
  },
  {
    name: reset_45pin7CKcxd04hmMeta?.name ?? "reset-pin___en",
    path: reset_45pin7CKcxd04hmMeta?.path ?? "/en/reset-pin",
    meta: reset_45pin7CKcxd04hmMeta || {},
    alias: reset_45pin7CKcxd04hmMeta?.alias || [],
    redirect: reset_45pin7CKcxd04hmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/reset-pin.vue").then(m => m.default || m)
  },
  {
    name: reset_45pin7CKcxd04hmMeta?.name ?? "reset-pin___fr",
    path: reset_45pin7CKcxd04hmMeta?.path ?? "/fr/reset-pin",
    meta: reset_45pin7CKcxd04hmMeta || {},
    alias: reset_45pin7CKcxd04hmMeta?.alias || [],
    redirect: reset_45pin7CKcxd04hmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/reset-pin.vue").then(m => m.default || m)
  },
  {
    name: indexrEmhM3k7xbMeta?.name ?? "security-legal-document___de",
    path: indexrEmhM3k7xbMeta?.path ?? "/de/security-legal-document",
    meta: indexrEmhM3k7xbMeta || {},
    alias: indexrEmhM3k7xbMeta?.alias || [],
    redirect: indexrEmhM3k7xbMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/security-legal-document/index.vue").then(m => m.default || m)
  },
  {
    name: indexrEmhM3k7xbMeta?.name ?? "security-legal-document___en",
    path: indexrEmhM3k7xbMeta?.path ?? "/en/security-legal-document",
    meta: indexrEmhM3k7xbMeta || {},
    alias: indexrEmhM3k7xbMeta?.alias || [],
    redirect: indexrEmhM3k7xbMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/security-legal-document/index.vue").then(m => m.default || m)
  },
  {
    name: indexrEmhM3k7xbMeta?.name ?? "security-legal-document___fr",
    path: indexrEmhM3k7xbMeta?.path ?? "/fr/security-legal-document",
    meta: indexrEmhM3k7xbMeta || {},
    alias: indexrEmhM3k7xbMeta?.alias || [],
    redirect: indexrEmhM3k7xbMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/security-legal-document/index.vue").then(m => m.default || m)
  },
  {
    name: simulatore2TEqHOXDxMeta?.name ?? "simulator___de",
    path: simulatore2TEqHOXDxMeta?.path ?? "/de/simulator",
    meta: simulatore2TEqHOXDxMeta || {},
    alias: simulatore2TEqHOXDxMeta?.alias || [],
    redirect: simulatore2TEqHOXDxMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/simulator.vue").then(m => m.default || m)
  },
  {
    name: simulatore2TEqHOXDxMeta?.name ?? "simulator___en",
    path: simulatore2TEqHOXDxMeta?.path ?? "/en/simulator",
    meta: simulatore2TEqHOXDxMeta || {},
    alias: simulatore2TEqHOXDxMeta?.alias || [],
    redirect: simulatore2TEqHOXDxMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/simulator.vue").then(m => m.default || m)
  },
  {
    name: simulatore2TEqHOXDxMeta?.name ?? "simulator___fr",
    path: simulatore2TEqHOXDxMeta?.path ?? "/fr/simulator",
    meta: simulatore2TEqHOXDxMeta || {},
    alias: simulatore2TEqHOXDxMeta?.alias || [],
    redirect: simulatore2TEqHOXDxMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/simulator.vue").then(m => m.default || m)
  },
  {
    name: indexFqd3lbx2VMMeta?.name ?? "support-tickets___de",
    path: indexFqd3lbx2VMMeta?.path ?? "/de/support-tickets",
    meta: indexFqd3lbx2VMMeta || {},
    alias: indexFqd3lbx2VMMeta?.alias || [],
    redirect: indexFqd3lbx2VMMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/support-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: indexFqd3lbx2VMMeta?.name ?? "support-tickets___en",
    path: indexFqd3lbx2VMMeta?.path ?? "/en/support-tickets",
    meta: indexFqd3lbx2VMMeta || {},
    alias: indexFqd3lbx2VMMeta?.alias || [],
    redirect: indexFqd3lbx2VMMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/support-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: indexFqd3lbx2VMMeta?.name ?? "support-tickets___fr",
    path: indexFqd3lbx2VMMeta?.path ?? "/fr/support-tickets",
    meta: indexFqd3lbx2VMMeta || {},
    alias: indexFqd3lbx2VMMeta?.alias || [],
    redirect: indexFqd3lbx2VMMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/support-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_936YhjF27tuCMeta?.name ?? "trading-buy-depotid___de",
    path: _91_91depotid_93_936YhjF27tuCMeta?.path ?? "/de/trading/buy/:depotid?",
    meta: _91_91depotid_93_936YhjF27tuCMeta || {},
    alias: _91_91depotid_93_936YhjF27tuCMeta?.alias || [],
    redirect: _91_91depotid_93_936YhjF27tuCMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/trading/buy/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_936YhjF27tuCMeta?.name ?? "trading-buy-depotid___en",
    path: _91_91depotid_93_936YhjF27tuCMeta?.path ?? "/en/trading/buy/:depotid?",
    meta: _91_91depotid_93_936YhjF27tuCMeta || {},
    alias: _91_91depotid_93_936YhjF27tuCMeta?.alias || [],
    redirect: _91_91depotid_93_936YhjF27tuCMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/trading/buy/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_936YhjF27tuCMeta?.name ?? "trading-buy-depotid___fr",
    path: _91_91depotid_93_936YhjF27tuCMeta?.path ?? "/fr/trading/buy/:depotid?",
    meta: _91_91depotid_93_936YhjF27tuCMeta || {},
    alias: _91_91depotid_93_936YhjF27tuCMeta?.alias || [],
    redirect: _91_91depotid_93_936YhjF27tuCMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/trading/buy/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93WQh3nPAOfIMeta?.name ?? "trading-delivery-depotid___de",
    path: _91_91depotid_93_93WQh3nPAOfIMeta?.path ?? "/de/trading/delivery/:depotid?",
    meta: _91_91depotid_93_93WQh3nPAOfIMeta || {},
    alias: _91_91depotid_93_93WQh3nPAOfIMeta?.alias || [],
    redirect: _91_91depotid_93_93WQh3nPAOfIMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/trading/delivery/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93WQh3nPAOfIMeta?.name ?? "trading-delivery-depotid___en",
    path: _91_91depotid_93_93WQh3nPAOfIMeta?.path ?? "/en/trading/delivery/:depotid?",
    meta: _91_91depotid_93_93WQh3nPAOfIMeta || {},
    alias: _91_91depotid_93_93WQh3nPAOfIMeta?.alias || [],
    redirect: _91_91depotid_93_93WQh3nPAOfIMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/trading/delivery/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93WQh3nPAOfIMeta?.name ?? "trading-delivery-depotid___fr",
    path: _91_91depotid_93_93WQh3nPAOfIMeta?.path ?? "/fr/trading/delivery/:depotid?",
    meta: _91_91depotid_93_93WQh3nPAOfIMeta || {},
    alias: _91_91depotid_93_93WQh3nPAOfIMeta?.alias || [],
    redirect: _91_91depotid_93_93WQh3nPAOfIMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/trading/delivery/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93GEdaDc0wI1Meta?.name ?? "trading-sell-depotid___de",
    path: _91_91depotid_93_93GEdaDc0wI1Meta?.path ?? "/de/trading/sell/:depotid?",
    meta: _91_91depotid_93_93GEdaDc0wI1Meta || {},
    alias: _91_91depotid_93_93GEdaDc0wI1Meta?.alias || [],
    redirect: _91_91depotid_93_93GEdaDc0wI1Meta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/trading/sell/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93GEdaDc0wI1Meta?.name ?? "trading-sell-depotid___en",
    path: _91_91depotid_93_93GEdaDc0wI1Meta?.path ?? "/en/trading/sell/:depotid?",
    meta: _91_91depotid_93_93GEdaDc0wI1Meta || {},
    alias: _91_91depotid_93_93GEdaDc0wI1Meta?.alias || [],
    redirect: _91_91depotid_93_93GEdaDc0wI1Meta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/trading/sell/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93GEdaDc0wI1Meta?.name ?? "trading-sell-depotid___fr",
    path: _91_91depotid_93_93GEdaDc0wI1Meta?.path ?? "/fr/trading/sell/:depotid?",
    meta: _91_91depotid_93_93GEdaDc0wI1Meta || {},
    alias: _91_91depotid_93_93GEdaDc0wI1Meta?.alias || [],
    redirect: _91_91depotid_93_93GEdaDc0wI1Meta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/trading/sell/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93EKe0ekZLN3Meta?.name ?? "trading-transfer-depotid___de",
    path: _91_91depotid_93_93EKe0ekZLN3Meta?.path ?? "/de/trading/transfer/:depotid?",
    meta: _91_91depotid_93_93EKe0ekZLN3Meta || {},
    alias: _91_91depotid_93_93EKe0ekZLN3Meta?.alias || [],
    redirect: _91_91depotid_93_93EKe0ekZLN3Meta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/trading/transfer/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93EKe0ekZLN3Meta?.name ?? "trading-transfer-depotid___en",
    path: _91_91depotid_93_93EKe0ekZLN3Meta?.path ?? "/en/trading/transfer/:depotid?",
    meta: _91_91depotid_93_93EKe0ekZLN3Meta || {},
    alias: _91_91depotid_93_93EKe0ekZLN3Meta?.alias || [],
    redirect: _91_91depotid_93_93EKe0ekZLN3Meta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/trading/transfer/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93EKe0ekZLN3Meta?.name ?? "trading-transfer-depotid___fr",
    path: _91_91depotid_93_93EKe0ekZLN3Meta?.path ?? "/fr/trading/transfer/:depotid?",
    meta: _91_91depotid_93_93EKe0ekZLN3Meta || {},
    alias: _91_91depotid_93_93EKe0ekZLN3Meta?.alias || [],
    redirect: _91_91depotid_93_93EKe0ekZLN3Meta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/trading/transfer/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: indexmcUOWVxIfvMeta?.name ?? "upvest-account-history___de",
    path: indexmcUOWVxIfvMeta?.path ?? "/de/upvest-account-history",
    meta: indexmcUOWVxIfvMeta || {},
    alias: indexmcUOWVxIfvMeta?.alias || [],
    redirect: indexmcUOWVxIfvMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/upvest-account-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexmcUOWVxIfvMeta?.name ?? "upvest-account-history___en",
    path: indexmcUOWVxIfvMeta?.path ?? "/en/upvest-account-history",
    meta: indexmcUOWVxIfvMeta || {},
    alias: indexmcUOWVxIfvMeta?.alias || [],
    redirect: indexmcUOWVxIfvMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/upvest-account-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexmcUOWVxIfvMeta?.name ?? "upvest-account-history___fr",
    path: indexmcUOWVxIfvMeta?.path ?? "/fr/upvest-account-history",
    meta: indexmcUOWVxIfvMeta || {},
    alias: indexmcUOWVxIfvMeta?.alias || [],
    redirect: indexmcUOWVxIfvMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/upvest-account-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexcPTOgg0GhUMeta?.name ?? "upvest-activate___de",
    path: indexcPTOgg0GhUMeta?.path ?? "/de/upvest-activate",
    meta: indexcPTOgg0GhUMeta || {},
    alias: indexcPTOgg0GhUMeta?.alias || [],
    redirect: indexcPTOgg0GhUMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/upvest-activate/index.vue").then(m => m.default || m)
  },
  {
    name: indexcPTOgg0GhUMeta?.name ?? "upvest-activate___en",
    path: indexcPTOgg0GhUMeta?.path ?? "/en/upvest-activate",
    meta: indexcPTOgg0GhUMeta || {},
    alias: indexcPTOgg0GhUMeta?.alias || [],
    redirect: indexcPTOgg0GhUMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/upvest-activate/index.vue").then(m => m.default || m)
  },
  {
    name: indexcPTOgg0GhUMeta?.name ?? "upvest-activate___fr",
    path: indexcPTOgg0GhUMeta?.path ?? "/fr/upvest-activate",
    meta: indexcPTOgg0GhUMeta || {},
    alias: indexcPTOgg0GhUMeta?.alias || [],
    redirect: indexcPTOgg0GhUMeta?.redirect,
    component: () => import("/home/forge/app.inaia.finance/pages/upvest-activate/index.vue").then(m => m.default || m)
  }
]